import { InvoiceTaxBase } from "../../invoicing/abstract/invoice-tax-base.model";


export class QuotationTax extends InvoiceTaxBase {

    static override CLASS_NAME: string = 'QuotationTax';

}
